import { useQuery } from '@tanstack/react-query';
import { unavailabilityOptions } from '../../constants/unavailabilities';
export function useUnavailabilities(filter, scope) {
    const { data, isLoading, isSuccess } = useQuery(unavailabilityOptions.get(filter, scope));
    return {
        unavailabilities: data ?? [],
        loadingUnavailabilities: isLoading,
        isSuccess,
    };
}
